import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';
import { AddTierRequest } from 'src/app/constants';

@Injectable({
	providedIn: 'root'
})
export class ManagementTierSetupService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	loadDataTierSetUp(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getTierSetup/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	addTier(request: AddTierRequest) {
		const InData  = {
			periodId: Number(request.periodId),
			tierName: request.tierName,
			tlmsRouteTypeCode: request.tlmsRouteTypeCode,
			masterTable: (request.masterTable),
			dependency: (request.dependency),
			lockTrigger: (request.lockTrigger),
			otherTierData: request.otherTierData,
			tierposition: Number(request.tierPos)
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/addTierSetup`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateTier(tierId, periodId, tierName, tlmsRouteTypeCode, masterTable, dependency, lockTrigger, otherTierData, tierPos) {
		const InData  = {
			tierId: Number(tierId),
			tierposition: Number(tierPos),
			periodId: Number(periodId),
			tierName: tierName,
			tlmsRouteTypeCode: tlmsRouteTypeCode,
			masterTable: (masterTable),
			dependency: (dependency),
			lockTrigger: (lockTrigger),
			otherTierData: otherTierData
		}
		return this.http.put(`${this.constantsService.baseAPIURL}/gimanagement/editTierSetup`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	copyTier(fromPeriod, toPeriod) {

		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/copyTierSetup/${fromPeriod}/${toPeriod}`, {}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	deleteTier(tierId): Observable<any> {
		return this.http
			.post(`${this.constantsService.baseAPIURL}/gimanagement/deleteTierSetup/${tierId}`, {}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}


	getTLMSRouteTypeCodes(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getRouteTypes`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}

	getOtherTierData(periodId): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getIncludeOtherTiers/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}
	getMasterTableDataDropDown(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/masterTbl`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}

	getDependencyAndLockTrigger(periodId): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getTiersByPeriodId/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}


	loadDataShuttle(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/gishuttle/getShuttle/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	addShuttle(tierId, minimumConnection, periodId, routeGroup, fifo, unloadBased) {
		const InData  = {

			tierId: Number(tierId),
			minimumConnection: Number(minimumConnection),
			periodId: Number(periodId),
			routeGroup: routeGroup,
			fifo: Number(fifo),
			unloadBased: Number(unloadBased)
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/gishuttle/addShuttle`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateShuttle(shuttleId, tierId, minimumConnection, fifo, unloadBased) {
		const InData  = {
			shuttleId: shuttleId,
			tierId: tierId,
			minimumConnection: minimumConnection,
			fifo: fifo,
			unloadBased: unloadBased
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/gishuttle/updateShuttle`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	deleteShuttle(shuttleId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/gishuttle/deleteShuttle/${shuttleId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	copyShuttle(fromPeriod, toPeriod) {
		const InData  = {
			fromPeriod: fromPeriod,
			toPeriod: toPeriod,
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/gishuttle/copyShuttle`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}


	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}